import { Component } from '@ecs/Component';

export class ShieldImpactRequest implements Component {
  readonly type = 'ShieldImpactRequest';
  
  constructor(
    public x: number,
    public y: number,
    public angle: number,
    public particleCount: number = 5,
    public particleColor: string = '#6666ff'
  ) {}
}